// Display helpers for raw enum values coming from the API.

// "not_connected" -> "Not Connected", "follow-up" -> "Follow Up", "new" -> "New"
export const formatLabel = (value, fallback = '—') => {
  if (value === null || value === undefined || value === '') return fallback;
  return String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

// pluralize(1, 'lead') -> "1 lead", pluralize(3, 'lead') -> "3 leads"
export const pluralize = (count, singular, plural) => {
  const n = Number(count) || 0;
  return `${n} ${n === 1 ? singular : (plural || `${singular}s`)}`;
};

// Backend labels that read misleadingly in the UI.
const PENDING_ACTION_LABELS = {
  'Calls Pending Today': 'Calls Left vs Daily Target',
};

export const relabelPendingAction = (name) => PENDING_ACTION_LABELS[name] || name;

// Backend alert titles use "require" for both singular and plural counts ("1 Hot Lead require attention").
export const fixAlertGrammar = (title) => {
  if (typeof title !== 'string') return title;
  return title.replace(/^(1\s+[^\d]*?[^s\s])\s+require\b/i, '$1 requires');
};
